import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.SourceServiceProxy,
        ApiServiceProxies.DataKeyServiceProxy,
        ApiServiceProxies.IndicatorServiceProxy,
        ApiServiceProxies.TransferTypeServiceProxy,
        ApiServiceProxies.EvaluationFormServiceProxy,
        ApiServiceProxies.EvaluationFormAnswerServiceProxy,
        ApiServiceProxies.EvaluationFormReportsServiceProxy,
        ApiServiceProxies.ReportsServiceProxy,
        ApiServiceProxies.IndicatorAnswerServiceProxy,
        ApiServiceProxies.TermServiceProxy,
        ApiServiceProxies.EvaluatedUniversityServiceProxy,
        ApiServiceProxies.EvaluationTeamServiceProxy,
        ApiServiceProxies.TeamEvaluatedUniversityServiceProxy,
        ApiServiceProxies.ExternalEvaluationAnswerServiceProxy,
        ApiServiceProxies.EvaluationFormCompletionServiceProxy,
        ApiServiceProxies.ReviewServiceProxy,
        ApiServiceProxies.IndicatorPerformanceReportServiceProxy,
        ApiServiceProxies.PreTrainingQuestionServiceProxy,
        ApiServiceProxies.TrainingQuestionServiceProxy,
        ApiServiceProxies.TrainingTestServiceProxy,
        ApiServiceProxies.PreTrainingTestServiceProxy,
        ApiServiceProxies.TrainingFileServiceProxy,
        ApiServiceProxies.TrainingReportAppServicesServiceProxy,
        ApiServiceProxies.UniversitiesInfoAppServicesServiceProxy,
        ApiServiceProxies.ExternalEvaluationTeamMemberConfirmServiceProxy,
        ApiServiceProxies.ExternalEvalutationUniverstyFeedbackServiceProxy,
        ApiServiceProxies.ExternalEvaluationSurveyQuestionServiceProxy,
        ApiServiceProxies.ExternalEvaluationSurveyServiceProxy,
        ApiServiceProxies.ExternalEvaluationSurveyRectorServiceProxy,
        ApiServiceProxies.AnnouncementServiceProxy,
        ApiServiceProxies.ProcessServiceProxy,
        ApiServiceProxies.ProcessDateServiceProxy,
        ApiServiceProxies.OpinionSuggestionServiceProxy,
        ApiServiceProxies.PreviousExternalEvaluationAnswerServiceProxy,
        ApiServiceProxies.ExternalEvaluationSurveyResultsServiceProxy,
        ApiServiceProxies.ExternalEvaluationStrengthsAndShortcomingsServiceProxy,
        ApiServiceProxies.EvaluationFormMaturityLevelServiceProxy,
        ApiServiceProxies.MatchEvaluationFormServiceProxy,
        ApiServiceProxies.EvaluationFormMentorServiceProxy,
        ApiServiceProxies.IserFeedbackFormServiceProxy,
        ApiServiceProxies.IserFeedbackFormAnswerServiceProxy,
        ApiServiceProxies.PrgAccQuestionServiceProxy,
        ApiServiceProxies.PrgAccFeedbackServiceProxy,
        ApiServiceProxies.UnivPrgAccServiceProxy,
        ApiServiceProxies.DistanceEducationEvaluationFeedbackServiceProxy,
        ApiServiceProxies.PrgAccFeedbackResultServiceProxy,
        ApiServiceProxies.HSIEvaluationServiceProxy,
        ApiServiceProxies.HSIEvaluationAnswerServiceProxy,
        ApiServiceProxies.ActivityManagementServiceProxy
    ]
})
export class ServiceProxyModule { }



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxy.module.ts